
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/order-for-delivery",
      function () {
        return require("private-next-pages/[slug]/order-for-delivery/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/order-for-delivery"])
      });
    }
  